<vd-drawer
  *ngIf="state() as s; else loadingTpl"
  [title]="'onboarding.title' | transloco"
  [subtitle]="
    isComplete()
      ? ('onboarding.subtitle_complete' | transloco)
      : ('onboarding.subtitle_remaining' | transloco: { count: remainingCount() })
  "
  icon="rocket_launch"
  tone="primary"
  width="lg"
  (closed)="close()"
>
  <!-- Header actions -->
  <ng-container vd-drawer-header-actions>
    <button
      type="button"
      class="onb-refresh-btn"
      (click)="refresh()"
      [attr.aria-label]="'common.refresh' | transloco"
      [disabled]="loading()"
    >
      <span class="material-icons-outlined" [class.is-spinning]="loading()">refresh</span>
    </button>
  </ng-container>

  <!-- ─── Progress hero ─── -->
  <section class="onb-progress-hero" [class.is-complete]="isComplete()">
    <div class="onb-progress-meta">
      <span class="onb-progress-pct">{{ progress() }}%</span>
      <span class="onb-progress-label">
        {{ 'onboarding.progress_label' | transloco: { done: s.done, total: s.total } }}
      </span>
    </div>
    <div class="onb-progress-track">
      <div
        class="onb-progress-fill"
        [style.width.%]="progress()"
        [class.is-complete]="isComplete()"
      ></div>
    </div>
    <p class="onb-progress-hint" *ngIf="!isComplete()">
      {{ 'onboarding.progress_hint' | transloco }}
    </p>
    <p class="onb-progress-hint is-success" *ngIf="isComplete()">
      {{ 'onboarding.progress_hint_complete' | transloco }}
    </p>
  </section>

  <!-- ─── Confettis si complet ─── -->
  <div class="onb-celebrate" *ngIf="congratsVisible()">
    <span class="onb-celebrate-emoji">🎉</span>
    <h3>{{ 'onboarding.ready_title' | transloco }}</h3>
    <p>
      {{ 'onboarding.ready_body' | transloco }}
    </p>
  </div>

  <!-- ─── Étapes groupées par phase ─── -->
  <section
    class="onb-phase"
    *ngFor="let group of groups(); trackBy: trackByPhase"
  >
    <header class="onb-phase-header">
      <div class="onb-phase-title">
        <span class="onb-phase-emoji">{{ group.emoji }}</span>
        <div>
          <h3>{{ group.labelKey | transloco }}</h3>
          <p>{{ group.descKey | transloco }}</p>
        </div>
      </div>
      <span class="onb-phase-count">{{ group.done }} / {{ group.total }}</span>
    </header>

    <ul class="onb-step-list">
      <li
        *ngFor="let step of group.steps; trackBy: trackByStep"
        class="onb-step"
        [attr.data-status]="statusTone(step.status)"
        [class.is-done]="step.status === 'done'"
      >
        <div class="onb-step-left">
          <span class="onb-step-icon">
            <span class="material-icons-outlined">{{ step.icon }}</span>
          </span>
        </div>

        <div class="onb-step-body">
          <div class="onb-step-top">
            <h4 class="onb-step-title">{{ stepTitle(step) }}</h4>
            <span class="onb-step-pill" [attr.data-status]="statusTone(step.status)">
              <span>{{ statusEmoji(step.status) }}</span>
              <span>{{ statusLabel(step.status) }}</span>
            </span>
          </div>
          <p class="onb-step-desc">{{ stepDescription(step) }}</p>
          <p class="onb-step-summary">{{ stepSummary(step) }}</p>
          <div class="onb-step-meta" *ngIf="step.estimated_min > 0 || step.required">
            <span *ngIf="step.estimated_min > 0" class="onb-meta-chip">
              <span class="material-icons-outlined">schedule</span>
              {{ 'onboarding.meta.duration' | transloco: { min: step.estimated_min } }}
            </span>
            <span *ngIf="step.required" class="onb-meta-chip is-required">
              <span class="material-icons-outlined">flag</span>
              {{ 'onboarding.meta.required' | transloco }}
            </span>
          </div>

          <div class="onb-step-actions" *ngIf="step.status !== 'done'">
            <vd-button
              variant="primary"
              size="sm"
              (click)="startStep(step)"
            >
              <span class="material-icons-outlined" slot="leading">arrow_forward</span>
              {{ stepCta(step) || ('onboarding.actions.start' | transloco) }}
            </vd-button>
            <button
              type="button"
              class="onb-dismiss-btn"
              (click)="dismiss(step, $event)"
              [title]="'onboarding.actions.remind_later' | transloco"
            >
              {{ 'onboarding.actions.later' | transloco }}
            </button>
          </div>
          <div class="onb-step-actions" *ngIf="step.status === 'done'">
            <vd-button
              variant="ghost"
              size="sm"
              (click)="startStep(step)"
            >
              <span class="material-icons-outlined" slot="leading">tune</span>
              {{ 'onboarding.actions.adjust' | transloco }}
            </vd-button>
          </div>
        </div>
      </li>
    </ul>
  </section>

  <!-- Footer -->
  <ng-container vd-drawer-footer>
    <div class="onb-footer">
      <span class="onb-footer-hint">
        {{ 'onboarding.footer_hint' | transloco }}
      </span>
      <vd-button variant="secondary" size="sm" (click)="close()">
        {{ 'common.close' | transloco }}
      </vd-button>
    </div>
  </ng-container>
</vd-drawer>

<ng-template #loadingTpl>
  <vd-drawer
    [title]="'onboarding.title' | transloco"
    [subtitle]="'onboarding.loading' | transloco"
    icon="rocket_launch"
    tone="primary"
    width="lg"
    (closed)="close()"
  >
    <div class="onb-loading">
      <div class="onb-skeleton onb-skeleton--bar"></div>
      <div class="onb-skeleton onb-skeleton--card" *ngFor="let _ of [1,2,3,4,5]"></div>
    </div>
  </vd-drawer>
</ng-template>
